import React, { Component } from 'react';
import './style.scss';

class RoadMap extends Component {
  render() {
    return (
      <section id="roadmap">
        <div className="row container-size">
          <div className="col-12">
            <div className="roadmap-head-wrap text-center">
              <span>
                <img
                  className="img-fluid"
                  src={require('../../../assets/icons/road-map.png')}
                  alt=""
                />{' '}
                DEVELOPMENT PROGRESS
              </span>
              <h1
                style={{
                  color: 'var(--h1Color)',
                  transition: 'color 0.2s ease-out, background 0.2s ease-out',
                }}
              >
                The Roadmap{' '}
              </h1>
            </div>
            <ul className="timeline">
              <li className="first-item">
                <div className="direction-l">
                  <div className="flag-wrapper">
                    <span className="badge badge-warning roadmap-badge">
                      In progress
                    </span>
                  </div>
                  <h2
                    className="timeline-desc-h2"
                    style={{
                      color: 'var(--h2Color)',
                      transition:
                        'color 0.2s ease-out, background 0.2s ease-out',
                    }}
                  >
                    MVP Launch: Tau Meta Language (TML)
                  </h2>
                  <div
                    className="timeline-desc"
                    style={{
                      color: 'var(--pColor)',
                      transition:
                        'color 0.2s ease-out, background 0.2s ease-out',
                    }}
                  >
                    We start by developing a metalanguage (TML) as a tool to
                    define new languages that can be translated among
                    themselves. TML will be a decidable language that holds
                    unique characteristic to interpret and redefine itself,
                    similar (but more expressive) to Datalog, as it allows
                    unrestricted [unstratified] negation. TML will also be able
                    to perform all computational tasks that are computable in
                    polynomial space. We learned from history's mistakes to
                    insist that our implementation will be highly optimized.
                  </div>
                </div>
              </li>

              <li className="second-item">
                <div className="direction-r">
                  <h2
                    className="timeline-desc-h2"
                    style={{
                      color: 'var(--h2Color)',
                      transition:
                        'color 0.2s ease-out, background 0.2s ease-out',
                    }}
                  >
                    Futamura's Projections
                  </h2>
                  <div
                    className="timeline-desc"
                    style={{
                      color: 'var(--pColor)',
                      transition:
                        'color 0.2s ease-out, background 0.2s ease-out',
                    }}
                  >
                    TML’s first mission is to define itself in the method of
                    Partial Evaluation, which gives rise to Futamura's
                    projections. It will be the first non-Turing-complete
                    implementation of Futamura's projections, the holy grail of
                    compilation abilities.
                  </div>
                </div>
              </li>

              <li className="third-item">
                <div className="direction-l">
                  <div className="flag-wrapper">
                    <span className="badge badge-warning roadmap-badge">
                      In progress
                    </span>
                  </div>
                  <h2
                    className="timeline-desc-h2"
                    style={{
                      color: 'var(--h2Color)',
                      transition:
                        'color 0.2s ease-out, background 0.2s ease-out',
                    }}
                  >
                    Alpha Version Launched
                  </h2>
                  <div
                    className="timeline-desc"
                    style={{
                      color: 'var(--pColor)',
                      transition:
                        'color 0.2s ease-out, background 0.2s ease-out',
                    }}
                  >
                    A fully featured knowledge economy allowing knowledge-cash
                    transactions, computational resources market, and advanced
                    financial tools.
                  </div>
                </div>
              </li>

              <li className="fourth-item">
                <div className="direction-r">
                  <h2
                    className="timeline-desc-h2"
                    style={{
                      color: 'var(--h2Color)',
                      transition:
                        'color 0.2s ease-out, background 0.2s ease-out',
                    }}
                  >
                    Beta Version Launched
                  </h2>
                  <div
                    className="timeline-desc"
                    style={{
                      color: 'var(--pColor)',
                      transition:
                        'color 0.2s ease-out, background 0.2s ease-out',
                    }}
                  >
                    A fully featured knowledge economy allowing knowledge-cash
                    transactions, computational resources market, and advanced
                    financial tools.
                  </div>
                </div>
              </li>

              <li className="fifth-item">
                <div className="direction-l">
                  <h2
                    className="timeline-desc-h2"
                    style={{
                      color: 'var(--h2Color)',
                      transition:
                        'color 0.2s ease-out, background 0.2s ease-out',
                    }}
                  >
                    Tau-Chain Launch
                  </h2>
                  <div
                    className="timeline-desc"
                    style={{
                      color: 'var(--pColor)',
                      transition:
                        'color 0.2s ease-out, background 0.2s ease-out',
                    }}
                  >
                    A fully featured knowledge economy allowing knowledge-cash
                    transactions, computational resources market, and advanced
                    financial tools. tools.
                  </div>
                </div>
              </li>

              <li className="sixth-item">
                <div className="direction-r">
                  <h2
                    className="timeline-desc-h2"
                    style={{
                      color: 'var(--h2Color)',
                      transition:
                        'color 0.2s ease-out, background 0.2s ease-out',
                    }}
                  >
                    Agoras
                  </h2>
                  <div
                    className="timeline-desc"
                    style={{
                      color: 'var(--pColor)',
                      transition:
                        'color 0.2s ease-out, background 0.2s ease-out',
                    }}
                  >
                    A fully featured knowledge economy allowing knowledge-cash
                    transactions, computational resources market, and advanced
                    financial tools.
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
    );
  }
}

export default RoadMap;
